import React from 'react';

const Stacked = () => <div>Stacked</div>;

export default Stacked;
